import { toCamelCaseDeep } from 'src/utils/transform';
import MemriseApi from '../MemriseApi';
import { SuccessResponse } from '../types';
import * as Types from './types';
import * as Schema from './schema';

export default class WordlistsApiClass extends MemriseApi {
  constructor() {
    super({ endpointPrefix: '/me' });
  }

  public async getWordlists(languagePairId: number): Promise<Types.WordlistsResponse> {
    const response = await this.get<Schema.WordlistsResponse>(
      `/language_pairs/${languagePairId}/wordlists/`,
    );
    return toCamelCaseDeep(response);
  }

  public async getWordlist(
    languagePairId: number,
    wordlistId: string,
  ): Promise<Types.WordlistResponse> {
    const response = await this.get<Schema.WordlistResponse>(
      `/language_pairs/${languagePairId}/wordlists/${wordlistId}/`,
    );
    return toCamelCaseDeep(response);
  }

  public async getWordlistLearnables(
    languagePairId: number,
    wordlistId: string,
    params: Schema.LearnablesStateRequest,
  ): Promise<Types.LearnablesStateResponse> {
    const response = await this.get<Schema.LearnablesStateResponse, Schema.LearnablesStateRequest>(
      `/language_pairs/${languagePairId}/wordlists/${wordlistId}/learnables/`,
      params,
    );
    return toCamelCaseDeep(response);
  }

  public async activateWordlist(
    languagePairId: number,
    wordlistId: string,
  ): Promise<SuccessResponse> {
    return this.post(`/language_pairs/${languagePairId}/wordlists/${wordlistId}/activate/`, {});
  }

  public async addLearnablesToWordlist(
    languagePairId: number,
    learnableIds: number[],
  ): Promise<SuccessResponse> {
    return this.post(`/language_pairs/${languagePairId}/wordlists/personal/update_learnables/`, {
      bodyObject: { learnable_ids: learnableIds },
    });
  }

  public async removeLearnablesFromWordlist(
    languagePairId: number,
    learnableIds: number[],
  ): Promise<SuccessResponse> {
    return this.delete(`/language_pairs/${languagePairId}/wordlists/personal/update_learnables/`, {
      bodyObject: { learnable_ids: learnableIds },
    });
  }
}

export const WordlistsApi = new WordlistsApiClass();
